import { render, staticRenderFns } from "./MediaArticlePage.vue?vue&type=template&id=50eabfd0&scoped=true"
import script from "./MediaArticlePage.vue?vue&type=script&lang=js"
export * from "./MediaArticlePage.vue?vue&type=script&lang=js"
import style0 from "./MediaArticlePage.vue?vue&type=style&index=0&id=50eabfd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eabfd0",
  null
  
)

export default component.exports